import { i18n } from "../i18n/i18n";

import React, { Component, Fragment } from 'react'
import contactSiteService from '../services/contactSite.service'
import vendorService from '../services/vendor.service'
import { ContactSiteData } from '../apis/contactSite.api'
import vendorApi, { VendorData } from '../apis/vendor.api'
import SearchPicker, { SearchPickerOption } from './SearchPicker'
import Select from './Select'

interface Props {
    vendor: string
    vendorSiteId: string
    vendors: VendorData[]
    vendorSites: ContactSiteData[]
    onVendorIdChange: (vendorId: number | null) => void
    onVendorSiteIdChange: (vendorId: string) => void
    onVendorChange: (vendor: string) => void
    onVendorsChange: (vendors: VendorData[]) => void
    onVendorSitesChange: (vendorSites: ContactSiteData[]) => void
}

export default class VendorAndSiteSelect extends Component<Props> {
  get vendorSearchOptions () {
    return vendorService.searchOptions(this.props.vendors)
  }

  get vendorSiteSelectOptions () {
    return contactSiteService.selectOptions(this.props.vendorSites)
  }

  listVendorSites (vendorId: number) {
    vendorApi.listSites(vendorId, vendorSites => {
      if (!vendorSites) return
      this.props.onVendorSitesChange(vendorSites)
    })
  }

  handleVendorSearch = (name: string, term: string) => {
    vendorApi.search(term, vendors => {
      if (!vendors) return
      this.props.onVendorsChange(vendors)
    })
  }

  handleVendorBlur = () => {
    this.props.onVendorsChange([])
  }

  handleVendorSelect = (name: string, option: SearchPickerOption) => {
    const id = option.id as number
    this.props.onVendorIdChange(id)
    this.props.onVendorsChange([])
    this.listVendorSites(id)
  }

  handleInputChange = (name: string, value: string) => {
    if (name === 'vendor') {
      this.props.onVendorIdChange(null)
      this.props.onVendorChange(value)
    } else if (name === 'vendorSiteId') {
      this.props.onVendorSiteIdChange(value)
    }
  }

  render () {
    return (
      <Fragment>
        <SearchPicker
          name="vendor"
          value={this.props.vendor}
          options={this.vendorSearchOptions}
          label={i18n("Vendor")}
          onSearch={this.handleVendorSearch}
          onSelect={this.handleVendorSelect}
          onChange={this.handleInputChange}
          onBlur={this.handleVendorBlur} />
        <Select
          name="vendorSiteId"
          value={this.props.vendorSiteId}
          options={this.vendorSiteSelectOptions}
          label={i18n("Vendor site")}
          onChange={this.handleInputChange} />
      </Fragment>
    )
  }
}
